module.exports = new __parcel__URL__("battlepass_buy_button.425367a8.png").toString();